/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsRvTemplateData } from '../../models/mail-params-rv-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendRvMailBoxMail$Params {
      body: MailParamsRvTemplateData
}

export function sendRvMailBoxMail(http: HttpClient, rootUrl: string, params: SendRvMailBoxMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendRvMailBoxMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendRvMailBoxMail.PATH = '/sendMail/rv-mailbox';
